// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f8f432e2","453":"063a3725","667":"368a01ce"}[chunkId] + ".chunk.js";
};